/** Demo applicants — replace with API when hiring endpoints are available. */
export const MOCK_APPLICANTS = [
    {
        id: 1,
        name: 'Rajesh Kumar',
        role: 'Master Chef',
        status: 'Open to work',
        phone: '+91 98760 11223',
        email: 'rajesh.kumar@mail.com',
        resumeFile: 'Rajesh_Kumar_Chef.pdf',
        experienceYears: 12,
        preferredLocations: [
            { zipcode: '500081', area: 'Gachibowli', city: 'Hyderabad' },
            { zipcode: '500032', area: 'Banjara Hills', city: 'Hyderabad' },
        ],
    },
    {
        id: 2,
        name: 'Lakshmi Venkat',
        role: 'Sous Chef',
        status: 'Open to work',
        phone: '+91 98761 33445',
        email: 'lakshmi.venkat@mail.com',
        resumeFile: 'Lakshmi_Venkat_CV.pdf',
        experienceYears: 8,
        preferredLocations: [{ zipcode: '500081', area: 'Gachibowli', city: 'Hyderabad' }],
    },
    {
        id: 3,
        name: 'Arun Mehta',
        role: 'Line Cook',
        status: 'Open to work',
        phone: '+91 98762 55667',
        email: 'arun.mehta@mail.com',
        resumeFile: 'Arun_Mehta_Resume.pdf',
        experienceYears: 5,
        preferredLocations: [{ zipcode: '500090', area: 'Kondapur', city: 'Hyderabad' }],
    },
    {
        id: 4,
        name: 'Priya Sharma',
        role: 'Server',
        status: 'Open to work',
        phone: '+91 98763 77889',
        email: 'priya.sharma@mail.com',
        resumeFile: 'Priya_Sharma_FOH.pdf',
        experienceYears: 4,
        preferredLocations: [
            { zipcode: '560034', area: 'Koramangala', city: 'Bengaluru' },
            { zipcode: '560103', area: 'Bellandur', city: 'Bengaluru' },
        ],
    },
    {
        id: 5,
        name: 'Vikram Singh',
        role: 'Bartender',
        status: 'Open to work',
        phone: '+91 98764 99001',
        email: 'vikram.singh@mail.com',
        resumeFile: 'Vikram_Singh_Bar.pdf',
        experienceYears: 6,
        preferredLocations: [{ zipcode: '110016', area: 'Hauz Khas', city: 'New Delhi' }],
    },
    {
        id: 6,
        name: 'Anita Desai',
        role: 'Host',
        status: 'Open to work',
        phone: '+91 98765 11234',
        email: 'anita.desai@mail.com',
        resumeFile: 'Anita_Desai_Host.pdf',
        experienceYears: 3,
        preferredLocations: [{ zipcode: '400050', area: 'Bandra West', city: 'Mumbai' }],
    },
    {
        id: 7,
        name: 'Mohammed Ali',
        role: 'Prep Cook',
        status: 'Open to work',
        phone: '+91 98766 22345',
        email: 'mohammed.ali@mail.com',
        resumeFile: 'Mohammed_Ali_Prep.pdf',
        experienceYears: 2,
        preferredLocations: [{ zipcode: '500081', area: 'Gachibowli', city: 'Hyderabad' }],
    },
    {
        id: 8,
        name: 'Sneha Reddy',
        role: 'Pastry Chef',
        status: 'Open to work',
        phone: '+91 98767 33456',
        email: 'sneha.reddy@mail.com',
        resumeFile: 'Sneha_Reddy_Pastry.pdf',
        experienceYears: 7,
        preferredLocations: [{ zipcode: '600042', area: 'Velachery', city: 'Chennai' }],
    },
    {
        id: 9,
        name: 'Karthik Nair',
        role: 'Delivery Lead',
        status: 'Open to work',
        phone: '+91 98768 44567',
        email: 'karthik.nair@mail.com',
        resumeFile: 'Karthik_Nair_Ops.pdf',
        experienceYears: 9,
        preferredLocations: [
            { zipcode: '560103', area: 'Bellandur', city: 'Bengaluru' },
            { zipcode: '500090', area: 'Kondapur', city: 'Hyderabad' },
        ],
    },
    {
        id: 10,
        name: 'Divya Iyer',
        role: 'Shift Manager',
        status: 'Open to work',
        phone: '+91 98769 55678',
        email: 'divya.iyer@mail.com',
        resumeFile: 'Divya_Iyer_Manager.pdf',
        experienceYears: 11,
        preferredLocations: [{ zipcode: '600042', area: 'Velachery', city: 'Chennai' }],
    },
];

export function isHiringAnyAreaInCity(loc) {
    if (!loc || typeof loc !== 'object') return false;
    return Boolean(loc.anyAreaInCity ?? loc.any_area_in_city);
}

export function formatHiringLocationPrimary(loc) {
    if (!loc || typeof loc !== 'object') return '—';
    if (isHiringAnyAreaInCity(loc)) return 'Any location';
    const zip = String(loc.zipcode ?? '').trim();
    return zip || '—';
}

export function formatHiringLocationSecondary(loc) {
    if (!loc || typeof loc !== 'object') return '—';
    const city = String(loc.city ?? loc.cityName ?? '').trim();
    if (isHiringAnyAreaInCity(loc)) return city || '—';
    const area = String(loc.area ?? loc.areaName ?? '').trim();
    if (area && city) return `${area}, ${city}`;
    return area || city || '—';
}

export function getHiringLocationKey(loc) {
    if (!loc || typeof loc !== 'object') return '';
    if (isHiringAnyAreaInCity(loc)) {
        const id = loc.preferredLocationId ?? loc.preferred_location_id;
        if (id != null) return `any-area|${id}`;
        const city = String(loc.city ?? loc.cityName ?? '').trim();
        return city ? `any-area|${city}` : 'any-area|';
    }
    return `${String(loc.zipcode ?? '').trim()}|${String(loc.area ?? '').trim()}|${String(loc.city ?? '').trim()}`;
}

export function formatHiringLocationLabel(loc) {
    if (!loc || typeof loc !== 'object') return '';
    if (isHiringAnyAreaInCity(loc)) {
        const city = String(loc.city ?? loc.cityName ?? '').trim();
        return city ? `Any location — ${city}` : 'Any location';
    }
    const zip = String(loc.zipcode ?? '').trim();
    const area = String(loc.area ?? '').trim();
    const city = String(loc.city ?? '').trim();
    if (!zip && !area && !city) return '';
    return `${zip} — ${area}, ${city}`;
}

/** Unique location options for filters (zipcode + area + city). */
export function getHiringLocationOptions(applicants = []) {
    const map = new Map();
    applicants.forEach((applicant) => {
        (applicant.preferredLocations || []).forEach((loc) => {
            const key = getHiringLocationKey(loc);
            if (!key || map.has(key)) return;
            map.set(key, {
                key,
                preferredLocationId: loc.preferredLocationId,
                zipcode: loc.zipcode,
                area: loc.area,
                city: loc.city,
                anyAreaInCity: isHiringAnyAreaInCity(loc),
                label: formatHiringLocationLabel(loc),
            });
        });
    });
    return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
}

export function hiringCityFilterFromPlaceDetails(placeDetails) {
    if (!placeDetails || typeof placeDetails !== 'object') return null;
    const city = String(placeDetails.city ?? '').trim();
    if (!city) return null;
    return { city };
}

export function formatHiringCityFilterLabel(filter) {
    if (!filter || typeof filter !== 'object') return '';
    return String(filter.city ?? '').trim();
}

function preferredLocationMatchesFields(loc, { zip, area, city }) {
    if (isHiringAnyAreaInCity(loc)) {
        if (zip || area) return false;
        if (!city) return true;
        const locCity = String(loc.city ?? loc.cityName ?? '').trim().toLowerCase();
        return locCity.includes(city);
    }

    const locZip = String(loc.zipcode ?? '').trim().toLowerCase();
    const locArea = String(loc.area ?? loc.areaName ?? '').trim().toLowerCase();
    const locCity = String(loc.city ?? loc.cityName ?? '').trim().toLowerCase();

    if (zip && locZip !== zip && !locZip.startsWith(zip)) return false;
    if (area && !locArea.includes(area)) return false;
    if (city && !locCity.includes(city)) return false;
    return true;
}

export function applicantMatchesLocationFilter(applicant, filterOrKeys) {
    if (!filterOrKeys) return true;

    if (Array.isArray(filterOrKeys)) {
        if (!filterOrKeys.length) return true;
        const keys = (applicant.preferredLocations || []).map(getHiringLocationKey).filter(Boolean);
        return filterOrKeys.some((k) => keys.includes(k));
    }

    const filter = filterOrKeys;
    const zip = String(filter.zipcode ?? '').trim().toLowerCase();
    const area = String(filter.area ?? filter.areaName ?? '').trim().toLowerCase();
    const city = String(filter.city ?? '').trim().toLowerCase();

    if (!zip && !area && !city) return true;

    return (applicant.preferredLocations || []).some((loc) =>
        preferredLocationMatchesFields(loc, { zip, area, city })
    );
}

export const MOCK_APPLICATIONS = [
    { id: 1, applicantName: 'Rajesh Kumar', role: 'Master Chef', appliedDate: '2026-05-18', status: 'Under review' },
    { id: 2, applicantName: 'Priya Sharma', role: 'Server', appliedDate: '2026-05-20', status: 'Interview scheduled' },
    { id: 3, applicantName: 'Vikram Singh', role: 'Bartender', appliedDate: '2026-05-22', status: 'New' },
];

export function getApplicantInitials(name) {
    const parts = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
